module.exports = "/_next/static/images/2-2-c9f895b3136a678359953c61d11c4f32.svg";